import styled from 'styled-components';

import { Flex } from '@/components/Flex';

export const Wrapper = styled(Flex)`
  a {
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

export const SpacerBottom = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2.5)};
`;
